import { Validator } from '@vista-digital/validator';
import { FilmSynopsisLength } from '../../../../types/film-synopsis-length';
/**
 * Default configuration options for the Film Synopsis component.
 */
export const defaultFilmSynopsisConfig = {
    length: FilmSynopsisLength.Longest
};
export const filmSynopsisConfigValidatorSchema = {
    length: Validator.oneOf(Object.values(FilmSynopsisLength))
};
export const filmSynopsisConfigValidator = Validator.object(filmSynopsisConfigValidatorSchema);
